import React from 'react';
import { useTranslate } from '@tolgee/react';
import { RowStatus } from '../../../../../redux/slices/bulkPostsImport';
import {PLATFORM_DISPLAY_NAME_KEYS} from "../../../../../config/icons"; // Adjust path if needed

interface ResultsTableBodyProps {
    rowStatuses: RowStatus[];
}

export const ResultsTableBody: React.FC<ResultsTableBodyProps> = ({ rowStatuses }) => {
    const { t } = useTranslate();

    const getStatusBadgeClass = (status: RowStatus['status']): string => {
        switch (status) {
            case 'Success':
                return 'badge bg-success text-white';
            case 'Failed':
                return 'badge bg-danger text-white';
            case 'Cancelled':
            case 'Pending':
                return 'badge bg-light text-dark';
            default:
                return 'badge bg-info text-white';
        }
    };

    return (
        <div className="table-responsive my-3">
            <table className="table table-striped table-hover mb-0"> 
                <thead>
                    <tr>
                        <th className="fw-bold" scope="col">{t("lomavisCreator.bulkPostsImportModal.row")}</th>
                        <th className="fw-bold" scope="col">{t("lomavisCreator.bulkPostsImportModal.platforms")}</th>
                        <th className="fw-bold" scope="col">{t("lomavisCreator.bulkPostsImportModal.status")}</th>
                        <th className="fw-bold" scope="col">{t("lomavisCreator.bulkPostsImportModal.details")}</th>
                    </tr>
                </thead>
                <tbody>
                    {rowStatuses.map((row) => (
                        <tr key={row.index}>
                            <td className="align-middle">{row.originalRowNumber}</td>

                            <td className="align-middle">
                                {row.platforms && row.platforms.length > 0
                                    ? row.platforms.map(x => t(PLATFORM_DISPLAY_NAME_KEYS[x])).join(', ')
                                    : <span className="text-muted">{t('N/A')}</span> /* Use muted text for N/A */}
                            </td>
                            <td className="align-middle">
                                <span className={getStatusBadgeClass(row.status)}>
                                    {t(`status.${row.status}`, row.status)}
                                </span>
                            </td>

                            <td className="align-middle">
                                {row.status === 'Failed' && row.error ? (
                                    <div className="text-danger">{row.error.map(err => (
                                        <div key={err.error} >
                                            {t(`lomavisCreator.bulkPostsImportModal.error.${err.error}`)}
                                        </div>
                                    ))}</div>
                                ) : (
                                    <div className="text-muted">-</div>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};